import React from "react";
import Pdf from "react-to-pdf";
import { PrimaryButton } from "../../../styles/colors";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router";

const PdfView = (props) => {
  let data = props.location.state.data;
  let ref = React.createRef();
  const history = useHistory();
  const amount = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };
  return (
    <>
      {data.map((e) => (
        <div>
          <div className={"transaction-detail-header"}>
            <div
              style={{
                backgroundColor: PrimaryButton,
                height: 30,
                width: 30,
                borderRadius: 5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              role="presentation"
              onClick={() => history.goBack()}
            >
              <ArrowBackIcon style={{ color: "white", fontSize: 20 }} />
            </div>
            <div
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                fontWeight: "bold",
                fontSize: 16,
                flex: 1,
                alignItems: "center",
                display: "flex",
              }}
            >
              Go Back
            </div>
          </div>
          <div ref={ref}>
            <h1>Name: {e.student.firstName + " " + e.student.lastName}</h1>
            <p>Amount :{amount(e.amount)}</p>
            <p>studentId :{e.studentId}</p>
          </div>
          <Pdf targetRef={ref} filename="TransactionReceipt.pdf">
            {({ toPdf }) => (
              <button className="btn btn-primary" onClick={toPdf}>
                Create Pdf
              </button>
            )}
          </Pdf>
        </div>
      ))}
    </>
  );
};

export default PdfView;
